import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Typography } from '@mui/material';

interface WorkboardDealGroupHeaderProps {
  dealName: string;
  valuationCount: number;
  isCollapsed: boolean;
  onToggle: () => void;
  // Injected by ScalarSpreadsheet:
  cell?: unknown;
  disabled?: boolean;
}

const WorkboardDealGroupHeader = ({
  dealName,
  valuationCount,
  isCollapsed,
  onToggle,
}: WorkboardDealGroupHeaderProps) => {
  const expanded = !isCollapsed;
  const countLabel = `(${valuationCount} valuation${valuationCount > 1 ? 's' : ''})`;

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'inline-flex',
        gap: 4,
        minWidth: 0,
        whiteSpace: 'nowrap',
      }}>
      <IconButton
        size="small"
        onClick={event => {
          event.stopPropagation();
          onToggle();
        }}
        onMouseDown={event => event.stopPropagation()}
        aria-expanded={expanded}
        aria-label={expanded ? `Collapse ${dealName}` : `Expand ${dealName}`}
        sx={{ p: 0.25, mr: 0.25 }}
        data-testid="workboard-deal-group-toggle">
        {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </IconButton>
      <Typography component="span" variant="body2" sx={{ fontWeight: 600 }}>
        {dealName}
      </Typography>
      <Typography component="span" variant="body2" sx={{ ml: 0.5, color: 'text.secondary', fontWeight: 400 }}>
        {countLabel}
      </Typography>
    </div>
  );
};

export default WorkboardDealGroupHeader;
